export default "__VITE_ASSET__DIZ5ZEhY__"